<mat-form-field class="w-100">
  <mat-label>{{label}}</mat-label>
  <mat-select [(ngModel)]="model" [required]="isRequired" (ngModelChange)="onModelChange()" [multiple]="isMultiple" (openedChange)="searchText = ''" [disabled]="isDisabled">
    <input placeholder="Search" matInput [(ngModel)]="searchText" class="select-input-search">
    @for (item of list | search: searchText; track item) {
      <mat-option [value]="item.id">{{item.name}}</mat-option>
    }
  </mat-select>
</mat-form-field>
